/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripDayNotOptimalReasonType = {
    Unknown: 'Unknown',
    TaxiTripCreated: 'TaxiTripCreated',
    TaxiTripDeleted: 'TaxiTripDeleted',
    TaxiTripUpdated: 'TaxiTripUpdated',
    TaxiTripUncancelled: 'TaxiTripUncancelled',
    TaxiTripCancelledByPassenger: 'TaxiTripCancelledByPassenger',
    TaxiTripManuallyAutoAssigned: 'TaxiTripManuallyAutoAssigned',
    TaxiTripAddedToTour: 'TaxiTripAddedToTour',
    TaxiTripMovedBetweenTours: 'TaxiTripMovedBetweenTours',
    TaxiTripRemovedFromTour: 'TaxiTripRemovedFromTour',
    VehicleSwappedOnTour: 'VehicleSwappedOnTour',
    TourDissolvedInfeasible: 'TourDissolvedInfeasible',
    RecurringTripTemplateUpdated: 'RecurringTripTemplateUpdated',
    RecurringTripSeriesDeleted: 'RecurringTripSeriesDeleted',
    RecurringTripDeviationCreated: 'RecurringTripDeviationCreated',
    RecurringTripDeviationDeleted: 'RecurringTripDeviationDeleted',
    RecurringTripOccurrencesGenerated: 'RecurringTripOccurrencesGenerated',
    VehicleTimeoutSpanChanged: 'VehicleTimeoutSpanChanged',
    PassengerEdited: 'PassengerEdited',
    TaxiVehicleEdited: 'TaxiVehicleEdited',
    TaxiAttendantEdited: 'TaxiAttendantEdited',
    PinnedTourWarningAppeared: 'PinnedTourWarningAppeared',
    TourPatternStopOrderInfeasible: 'TourPatternStopOrderInfeasible'
} as const;
export type TaxiTripDayNotOptimalReasonType = typeof TaxiTripDayNotOptimalReasonType[keyof typeof TaxiTripDayNotOptimalReasonType];

